//TODO: Hvis fejlbesked på sidste side (fx udsolgt)

import angular from "angular";
import DateExtended from "serviceJs/date.service.ts";

import "../../../services/product";
import "../../../services/cart";
import "../../../services/datastorage";

import "./tickets";
import "./accessories";

angular.module("folkeuni").component("productConfiguration", {
    bindings: {
        areaId: "<",
        categoryUrl: "@",
        checkoutUrl: "@",
        currentProgramPage: "@",
        siteName: "<",
        siteId: "<",
        productId: "@"
    },
    controller: function (Cart, DataStorage, Product, $timeout) {
        var $ctrl = this;
        $ctrl.product = null;
        $ctrl.errorTimer = null;

        $ctrl.accessorieSumup = [];

        $ctrl.currentOrderline = {
            error: {},
            step: null,
            tickets: []
        };
        $ctrl.currentOrderline.addToCart = function () {
            $ctrl.loading = true;
            $timeout.cancel($ctrl.errorTimer);
            $ctrl.statusMessage = null;
            var orderlinesToAdd = [];

            for (var i = 0; $ctrl.currentOrderline.tickets.length > i; i++) {
                var currentOrderline = $ctrl.currentOrderline.tickets[i];

                var orderline = {
                    productId: $ctrl.product.id,
                    courseId: currentOrderline.courseId,
                    type: currentOrderline.type
                };

                if (!orderline.options) {
                    orderline.options = [];
                }

                for (var y = 0; currentOrderline.accessories.length > y; y++) {
                    orderline.options.push(currentOrderline.accessories[y].id);
                }
                orderlinesToAdd.push(orderline);
            }

            Cart.add(orderlinesToAdd).then(
                function (cartAnswer) {
                    let dataLayerAmount = 0;
                    let currentProductId = orderlinesToAdd[0].productId;

                    for (var i = 0; $ctrl.product.prices.length > i; i++) {
                        var currentPrice = $ctrl.product.prices[i];
                        for (var y = 0; orderlinesToAdd.length > y; y++) {
                            var currentOrderline = orderlinesToAdd[y];
                            if (currentOrderline.type == currentPrice.type) {
                                dataLayerAmount += Number(currentPrice.value.split(",")[0]);
                            }
                        }
                    }

                    if (dataLayer && $ctrl.siteId == 1) {
                        dataLayer.push({
                            event: "viewProduct",
                            productId: currentProductId,
                            productDefaultPrice: dataLayerAmount
                        });
                    }
                    window.location = $ctrl.checkoutUrl;
                },
                function (errorResponse) {
                    var errorData = errorResponse.data;
                    $ctrl.loading = false;
                    $ctrl.currentOrderline.step = 0;
                    if (errorData.errorCode == 60) {
                        //not enough available tickets
                        var availableTickets = errorData.items[0].available;
                        $ctrl.currentOrderline.error.message =
                            "Der er kun " + availableTickets + " pladser tilbage på holdet.";
                        $ctrl.errorTimer = $timeout(function () {
                            $ctrl.currentOrderline.error.message = null;
                        }, 5000);
                    } else if (errorData.error) {
                        $ctrl.currentOrderline.error.message = errorData.error;

                        $ctrl.errorTimer = $timeout(function () {
                            $ctrl.currentOrderline.error.message = null;
                        }, 5000);
                    } else {
                        $ctrl.currentOrderline.error.message =
                            "Der er sket en fejl, prøv venligst igen senere eller kontakt os.";
                        $ctrl.errorTimer = $timeout(function () {
                            $ctrl.currentOrderline.error.message = null;
                        }, 5000);
                    }
                }
            );
        };
        $ctrl.$onInit = function () {
            $ctrl.scrollToTickets();

            Product.getProduct($ctrl.siteId, $ctrl.productId).then(
                function (product) {
                    product.startDateFormattet = new DateExtended(product.startDate).format(
                        "[dddd] d. [DD].[MM].[YYYY] kl. [HH]:[mm]"
                    );

                    $ctrl.product = product;
                    $ctrl.currentOrderline.step = 0;

                    for (var i = 0; $ctrl.product.courses.length > i; i++) {
                        for (var y = 0; $ctrl.product.courses[i].events.length > y; y++) {
                            $ctrl.product.courses[i].events[y].startDateFormattet = new DateExtended(
                                $ctrl.product.courses[i].events[y].startDate
                            ).format("[dddd] d. [DD].[MM].[YYYY] kl. [HH]:[mm]");
                        }
                    }
                },
                function (errorResponse) {}
            );
            if (window.Clerk != null) {
                setTimeout(() => {
                    window.Clerk("content", ".clerk-recommendations");
                }, 10);
            }
        };
        $ctrl.scrollToTickets = function () {
            setTimeout(function () {
                const element = document.querySelector(".tickets-container");
                if (element) {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                }
            }, 500);
        };
    },
    templateUrl: "/shop-dist/templates/product-configuration.html?c=" + window.cacheBurst,
    transclude: false
});
